module.exports = __webpack_public_path__ + "img/img1.7b129e54.jpg";